// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbot-application-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 90px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
}

.chatbot-application-image {
  position: relative;
  width: 22%;
  order: 1;

  margin-top: 30px;
}

.services-image {
  width: 100%;
  height: 50%;
  border-radius: 8px;
  margin: 0;
  display: block;
}

.chatbot-application-text {
  width: 62%;
  order: 2;
  margin-top: -45px;
  margin-right: 65px;
}

.chatbot-application-text h1 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 2rem;
  color: #333;
  text-align: left;
}
.chatbot-application-text h2 {
  font-size: 1em;
  color: #555;
  margin-bottom: 20px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 0;
}

.services-list li {
  width: 45%;
  font-size: 0.9em;
  color: #333;
}

.chatbot-application-button {
  background-color: #00c853;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.chatbot-application-button:hover {
  background-color: #009624;
}

@media (max-width: 768px) {
  .chatbot-application-container {
    flex-direction: column;
    align-items: left;
    text-align: left;
    gap: 20px;
  }

  .chatbot-application-text {
    width: 150%;
    margin-right: 10px;
    order: 2;
  }

  .chatbot-application-image {
    width: 150%;
    margin-top: 50px;
    order: 1;
  }

  .services-list li {
    width: 100%;
  }
}

@media (min-width: 1380px) and (max-width: 1919px) {
  .chatbot-application-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 90px;
  }

  .chatbot-application-image {
    width: 19%;
    margin-top: 60px;
    margin-left: 50px;
  }

  .chatbot-application-text {
    width: 68%;
    margin-top: -10px;
  }

  .chatbot-application-text h1 {
    font-size: 1.8rem;
  }

  .chatbot-application-text p {
    font-size: 0.95em;
  }

  .services-list li {
    width: 48%;
  }

  .chatbot-application-button {
    font-size: 1em;
    padding: 10px 18px;
  }
}

@media (min-width: 1920px) {
  .chatbot-application-container {
    max-width: 1600px;
    margin: 0 auto;
    padding: 100px;
  }

  .chatbot-application-image {
    width: 40%;
    margin-top: 0;
  }

  .chatbot-application-text {
    width: 55%;
    margin-top: 0;
  }

  .chatbot-application-text h1 {
    font-size: 2.5rem;
  }

  .chatbot-application-text p {
    font-size: 1.1rem;
  }

  .services-list li {
    width: 42%;
  }

  .chatbot-application-button {
    font-size: 1.1em;
    padding: 15px 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatbotApplication/ChatbotApplication.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;;EAER,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":[".chatbot-application-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 90px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n}\n\n.chatbot-application-image {\n  position: relative;\n  width: 22%;\n  order: 1;\n\n  margin-top: 30px;\n}\n\n.services-image {\n  width: 100%;\n  height: 50%;\n  border-radius: 8px;\n  margin: 0;\n  display: block;\n}\n\n.chatbot-application-text {\n  width: 62%;\n  order: 2;\n  margin-top: -45px;\n  margin-right: 65px;\n}\n\n.chatbot-application-text h1 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n  font-size: 2rem;\n  color: #333;\n  text-align: left;\n}\n.chatbot-application-text h2 {\n  font-size: 1em;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none;\n  padding: 0;\n}\n\n.services-list li {\n  width: 45%;\n  font-size: 0.9em;\n  color: #333;\n}\n\n.chatbot-application-button {\n  background-color: #00c853;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.chatbot-application-button:hover {\n  background-color: #009624;\n}\n\n@media (max-width: 768px) {\n  .chatbot-application-container {\n    flex-direction: column;\n    align-items: left;\n    text-align: left;\n    gap: 20px;\n  }\n\n  .chatbot-application-text {\n    width: 150%;\n    margin-right: 10px;\n    order: 2;\n  }\n\n  .chatbot-application-image {\n    width: 150%;\n    margin-top: 50px;\n    order: 1;\n  }\n\n  .services-list li {\n    width: 100%;\n  }\n}\n\n@media (min-width: 1380px) and (max-width: 1919px) {\n  .chatbot-application-container {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 90px;\n  }\n\n  .chatbot-application-image {\n    width: 19%;\n    margin-top: 60px;\n    margin-left: 50px;\n  }\n\n  .chatbot-application-text {\n    width: 68%;\n    margin-top: -10px;\n  }\n\n  .chatbot-application-text h1 {\n    font-size: 1.8rem;\n  }\n\n  .chatbot-application-text p {\n    font-size: 0.95em;\n  }\n\n  .services-list li {\n    width: 48%;\n  }\n\n  .chatbot-application-button {\n    font-size: 1em;\n    padding: 10px 18px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .chatbot-application-container {\n    max-width: 1600px;\n    margin: 0 auto;\n    padding: 100px;\n  }\n\n  .chatbot-application-image {\n    width: 40%;\n    margin-top: 0;\n  }\n\n  .chatbot-application-text {\n    width: 55%;\n    margin-top: 0;\n  }\n\n  .chatbot-application-text h1 {\n    font-size: 2.5rem;\n  }\n\n  .chatbot-application-text p {\n    font-size: 1.1rem;\n  }\n\n  .services-list li {\n    width: 42%;\n  }\n\n  .chatbot-application-button {\n    font-size: 1.1em;\n    padding: 15px 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
